import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en/en.json';

export const defaultNS = 'en';

i18next.use(initReactI18next).init({
    lng: 'en', // if you're using a language detector, do not define the lng option
    debug: process.env.NODE_ENV === 'development',
    resources: {
        en: {
            en,
        },
    },
    defaultNS,
    fallbackLng: 'en',
    interpolation: {
        escapeValue: false, // React already does escaping
    },
});
